import React from "react";
import "./analytics.css";
import SideNav from "../../../component/sideNav";
import AnalyticsDetail from "./analyticsDetail";
import Header from "../../../component/header";

export default function Analytics() {
  return (
    <div className="analyticsContainer">
      <Header></Header>
      <SideNav active="Dashboard" />
      <div className="analyticsContent">
        <AnalyticsDetail></AnalyticsDetail>
      </div>
    </div>
  );
}
